import React from 'react';
import IpCheckerBlock from 'components/Checkers/IpCheckerBlock';
import { IpQueryContextProvider } from 'context/IpQueryContext';

const IpCheckerPage = () => {
  return (
    <div>
      <IpQueryContextProvider>
        <IpCheckerBlock />
      </IpQueryContextProvider>
    </div>
  );
};

export default IpCheckerPage;
